<template>
  <div class="flex items-center">
    <CheckBox class="flex-1 tablet:mr-2 laptop:mr-0" :model-value="checked" size="small" @update:model-value="onChange">
      <span class="hyphens-auto">{{ facetName }}</span>
    </CheckBox>

    <div class="text-sm text-grey-600">
      {{ facet.count }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckBox } from '@ramp106/omrjs-core-ui'
import { snakeCase } from 'lodash-es'
import { computed } from 'vue'

import { useNuxtApp } from '#imports'
import type { SearchFacetFragment } from '~/gql/jobs/types.generated'

interface JobListFacetsItemEmits {
  (e: 'change', args: { facetId: string; isChecked: boolean }): void
}

interface JobListFacetsItemProps {
  checked: boolean
  facetType: string
  facet: SearchFacetFragment
  translated: boolean
}

const emit = defineEmits<JobListFacetsItemEmits>()

const props = defineProps<JobListFacetsItemProps>()

const { $i18n } = useNuxtApp()

const facetName = computed(() => {
  if (props.translated) {
    return $i18n.t(`job_list.sidebar.${snakeCase(props.facetType)}_filters.${props.facet.name}`)
  }

  return props.facet.name
})

const onChange = (isChecked: boolean) => {
  emit('change', {
    isChecked,
    facetId: props.facet.facetId,
  })
}
</script>
